import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const MpClients = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {

    },
    updated(){

    },
    mounted(){
        let mpSwiperClient = new Swiper($(this.$el).find('.js-clients-slider')[0], {
            loop: true,
            lazyPreloadPrevNext: 2, // соседи видимых: Swiper снимает loading у их картинок — сигнал модулю lazyload.js
            grabCursor: true,
            slidesPerView: 6,
            spaceBetween: 15,
            autoplay: {
              delay: 3000
            },
            navigation: {
              nextEl: ".js-clients-next",
              prevEl: ".js-clients-prev"
            },
            breakpoints: {
              320: {
                slidesPerView: 2.45,
                spaceBetween: 3
              },
              440: {
                slidesPerView: 3.4,
                spaceBetween: 3
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 15
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 15
              }
            }
          });
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section v-if="this.struct[this.structKey].componentData.ITEMS" :class="(this.struct[this.structKey].componentData.SECONDARY_PAGE !== false ? this.struct[this.structKey].componentData.SECONDARY_PAGE : 'clients__mp')">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Наши клиенты
                </h2>
                <div class="section__nav-arrows">
                    <div class="swiper-button-prev slider-btn js-clients-prev">
                        <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                    </div>
                    <div class="swiper-button-next slider-btn js-clients-next">
                        <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="swiper clients__slider js-clients-slider">
            <div class="swiper-wrapper">

                <div v-for="item in this.struct[this.structKey].componentData.ITEMS" class="swiper-slide">
                    <div class="clients__slide">
                        <a :href="item.first.LINK" class="clients__card">
                            <img class="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.first.PICTURE" :alt="item.first.NAME" :title="item.first.NAME" loading="lazy">
                        </a>
                        <a v-if="item.second" :href="item.second.LINK" class="clients__card">
                            <img class="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.second.PICTURE" :alt="item.second.NAME" :title="item.second.NAME" loading="lazy">
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
    `
}